/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";
import {useSnackbar} from "notistack";


const useProfileOverview = () => {

    // State storage of the users shown in the table
    const [signedInUserData, setSignedInUserData] = useState(null)
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the Moodle users and setting the list in the state variable
    const fetchSignedInUserData = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/profile?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const usersJson = await data.json();
                setSignedInUserData(usersJson)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.profile.messages.list.error',
                        defaultMessage: 'Something went wrong while loading the profile data: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchSignedInUserData();
    }, [])

    return {signedInUserData, loading}
}
export default useProfileOverview;